// components/CustomLoginCallback.tsx
import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useMsal} from '@azure/msal-react';
import {useDispatch, useSelector} from 'react-redux';
import {resetAppState, selectLastVisitedUrl} from 'app/store/appState/appStateSlice';
import {resetUserState, selectPreviousUserType, selectUserType, setPreviousUserType} from 'app/store/users/userSlice';

export const CustomLoginCallback = ({loadingElement}: {loadingElement?: React.ReactElement}) => {
  const navigate = useNavigate();
  const lastVisitedUrl = useSelector(selectLastVisitedUrl);
  const userType = useSelector(selectUserType);
  const previousUserType = useSelector(selectPreviousUserType);
  const dispatch = useDispatch();
  const {instance} = useMsal();

  useEffect(() => {
    const checkRedirect = async () => {
      // Handle MSAL redirect response
      try {
        await instance.handleRedirectPromise();

        // Wait a bit to ensure MSAL has finished login
        const redirect = lastVisitedUrl ?? '/';
        setTimeout(() => {
          if (userType !== previousUserType) {
            // If user type has changed, clear appState and redirect to the home page
            dispatch(resetAppState());
            dispatch(resetUserState());
            navigate('/home', {replace: true});
            dispatch(setPreviousUserType(userType));
            return;
          }

          navigate(redirect, {replace: true});
        }, 500); // short delay to let MSAL finish
      } catch (error) {
        console.error('MSAL redirect error:', error);
        navigate('/login', {replace: true});
      }
    };

    checkRedirect();
  }, [dispatch, instance, lastVisitedUrl, navigate, previousUserType, userType]);

  return loadingElement || null;
};
